<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <RouterLink
        class="h-full flex items-center justify-center px-8"
        :style="{ backgroundColor: sidebarColor, width: '35vw' }"
        to="/clients/login"
        aria-label="Client portal home"
      >
        <img
          v-if="portalConfig.logoUrl && !logoErrored"
          :src="portalConfig.logoUrl"
          :alt="portalConfig.companyName"
          class="max-h-16 max-w-[220px] object-contain"
          @error="logoErrored = true"
        />
        <div v-else class="text-white text-center">
          <span class="text-3xl font-bold">{{ companyInitial }}</span>
          <p v-if="portalConfig.companyName" class="mt-2 text-lg font-semibold">{{ portalConfig.companyName }}</p>
        </div>
      </RouterLink>
    </template>
    <template #content>
      <main class="h-full flex flex-col items-center justify-center mx-auto max-w-[420px] w-full px-6 py-8">
        <RouterView />
        <PoweredByValt />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px] w-full">
          <div class="flex flex-col items-start w-full min-h-full py-4">
            <RouterLink class="py-4 flex items-center gap-3" to="/clients/login" aria-label="Client portal home">
              <img
                v-if="portalConfig.logoUrl && !logoErrored"
                :src="portalConfig.logoUrl"
                :alt="portalConfig.companyName"
                class="max-h-10 max-w-[160px] object-contain"
                @error="logoErrored = true"
              />
              <span v-else class="text-xl font-bold text-primary">{{ portalConfig.companyName }}</span>
            </RouterLink>
            <RouterView />
            <PoweredByValt />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { useBreakpoint } from 'vuestic-ui'
import PoweredByValt from '@/components/client-portal/PoweredByValt.vue'
import { usePortalConfigStore } from '@/stores/portalConfigStore'

const breakpoint = useBreakpoint()
const portalConfig = usePortalConfigStore()
const logoErrored = ref(false)

watch(
  () => portalConfig.logoUrl,
  () => {
    logoErrored.value = false
  },
)

const sidebarColor = computed(() => portalConfig.primaryColor || 'var(--va-primary)')
const companyInitial = computed(() => portalConfig.companyName.charAt(0).toUpperCase() || 'C')
</script>
